import React from 'react';
import { Modal } from 'native-base';
import { useCustomerPortalEdit } from '../hooks/useCustomerPortalEdit';
import { Form } from '../../Form/components/Form';

export function DoctorCustomerEdit({
  customerID,
  closeModal,
}: {
  customerID: string;
  closeModal: () => void;
}) {
  const { saving, formSchema, loading, save } = useCustomerPortalEdit(customerID, closeModal);

  return (
    <Modal.Content>
      <Modal.CloseButton />
      <Modal.Header>Edit Customer</Modal.Header>

      <Modal.Body bg={'white'}>
        <Form
          formSchema={formSchema}
          onSubmit={save}
          submitButtonTitle={'Save'}
          loading={loading || saving}
        />
      </Modal.Body>
    </Modal.Content>
  );
}
